import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Box, Grid, makeStyles } from "@material-ui/core";
import translate from "i18n/translate";
import useRecoverPassword from "./useRecoverPassword";
import { AUTH_CONTAINER_WIDTH, AUTH_TITLE_SPACE } from "../../../../constants";
import {
  SrAlert,
  SrButton,
  Typography,
  SrInputPassword,
} from "../../../common";
import { validations } from "utils";

const initialValues = {
  password: "",
  confirmPassword: "",
};

const validationSchema = Yup.object().shape({
  password: validations.password.required(translate("common.requiredField")),
  confirmPassword: validations.password
    .oneOf([Yup.ref("password"), null], translate("common.passwordMatch"))
    .required(translate("common.requiredField")),
});

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: AUTH_CONTAINER_WIDTH,
  },
}));

const RecoverPassword = () => {
  const classes = useStyles();

  const { error, handleSubmit } = useRecoverPassword();

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        item
        justifyContent="center"
        className={classes.container}
      >
        <Grid item xs={12}>
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="h2" align="center">
              {translate("auth.recoverPassword")}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="subtitle1" align="center">
              {translate("auth.recoverPasswordSubtitle")}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              isSubmitting,
            }) => (
              <Form noValidate>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <SrInputPassword
                      label={translate("auth.newPassword")}
                      required
                      fullWidth
                      error={errors.password && touched.password}
                      helperText={touched.password && errors.password}
                      id="password"
                      name="password"
                      autoComplete="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <SrInputPassword
                      label={translate("auth.repeatNewPassword")}
                      required
                      fullWidth
                      error={errors.confirmPassword && touched.confirmPassword}
                      helperText={
                        touched.confirmPassword && errors.confirmPassword
                      }
                      name="confirmPassword"
                      id="confirmPassword"
                      autoComplete="current-confirmPassword"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirmPassword}
                    />
                  </Grid>
                  {error && (
                    <Grid item xs={12}>
                      <SrAlert severity="error">{error}</SrAlert>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <SrButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {translate("common.confirm")}
                    </SrButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RecoverPassword;
